import { ThemeOptions } from "@mui/material/styles";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#f5f5f5",
    },
    warning: {
      main: "#f7d702",
    },
    success: {
      main: "#047235",
    },
  },
};
